
import Component from '../../../assets/scripts/modules/component'
import SwiperWrapper from '../../../assets/scripts/modules/swiper-wrapper'

const SWIPER_OPTIONS_CONTENT = {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 60,
  // loopAdditionalSlides: null,
  allowTouchMove: false,
  grabCursor: false,
  effect: 'fade',
  fadeEffect: { crossFade: true },
  autoHeight: true
}

const SWIPER_OPTIONS_BUTTONS = {
  loop: true,
  slidesPerView: 'auto',
  slideToClickedSlide: true
  // Doesn't work when slideToClickedSlide = true
  // loopedSlides: 128,
  // loopAdittionalSlides: 128
}

export default class LifecycleCarouselComponent extends Component {
  async init () {
    this.observedIntersectionElements = this.element.querySelectorAll('.lifecycle-carousel__title, .lifecycle-carousel__buttons, .lifecycle-carousel__content, .lifecycle-carousel__navigation')

    this.buttonsContainer = this.element.querySelector('.lifecycle-carousel__buttons-container.swiper-container')
    this.contentContainer = this.element.querySelector('.lifecycle-carousel__content-container.swiper-container')
    this.buttonsWrapper = this.element.querySelector('.lifecycle-carousel__buttons-wrapper')

    if (!this.buttonsContainer || !this.contentContainer || !this.buttonsWrapper) {
      return
    }

    this.buttonCount = this.buttonsContainer.querySelectorAll('.swiper-slide').length
    this.realSlideCount = parseInt(this.buttonsWrapper.getAttribute('data-real-slide-count')) || this.buttonCount

    this.buttonPrev = this.element.querySelector('.swiper-button-prev')
    this.buttonNext = this.element.querySelector('.swiper-button-next')
    this.spanIndex = this.element.querySelector('.lifecycle-carousel__buttons-slide-index .icon-button__title')

    this.loadContentSwiper()
  }

  loadContentSwiper () {
    const options = { ...SWIPER_OPTIONS_CONTENT, ...{} }
    this.contentSwiperWrapper = new SwiperWrapper(this.contentContainer, options, [], {}, () => this.loadButtonsSwiper())
  }

  loadButtonsSwiper () {
    const options = { ...SWIPER_OPTIONS_BUTTONS, ...{ navigation: { prevEl: this.buttonPrev, nextEl: this.buttonNext } /*, controller: { control: this.contentSwiperWrapper.swiper, inverse: false, by: 'slide' } */ } }
    this.buttonsSwiperWrapper = new SwiperWrapper(this.buttonsContainer, options, [], {}, () => this.coupleSwipers())
  }

  coupleSwipers () {
    this.buttonsSwiperWrapper.swiper.on('slideChange', () => {
      this.updateIndex()
      // Using the buttons as a controller is very buggy since it's not 1 slide per view
      // Therefore, we'll switch slides manually. Not the prettiest, but at least it works.
      this.contentSwiperWrapper.swiper.slideToLoop(this.buttonsSwiperWrapper.swiper.realIndex)
    })

    this.updateIndex()
  }

  updateIndex () {
    if (!this.spanIndex) {
      return
    }

    const swiperIndex = this.buttonsSwiperWrapper.swiper.realIndex
    const count = (this.realSlideCount !== this.buttonCount) ? swiperIndex % this.realSlideCount : this.buttonCount

    this.spanIndex.innerText = count + 1
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.lifecycle-carousel').forEach(element => {
  element.instance = element.instance || new LifecycleCarouselComponent(element)
}))
